/**
 * Where page scripts put UI "just below the header" (electinfo/sites#270).
 *
 * The account row (#auth-slot, src/auth.ts) sits directly under the page's
 * <header>; search boxes and maps injected after the header go below it, so
 * the order is the same whichever script runs first.
 */

export const AUTH_SLOT_ID = 'auth-slot';

/** The page's own header: a direct child of <body>, else the first <header>. */
export function pageHeader(): HTMLElement | null {
  return document.querySelector<HTMLElement>('body > header') ?? document.querySelector<HTMLElement>('header');
}

/** The element to insertBefore() for content that belongs under the header. */
export function belowHeaderInsertPoint(): Element | null {
  const next = pageHeader()?.nextElementSibling ?? null;
  return next?.id === AUTH_SLOT_ID ? next.nextElementSibling : next;
}
